import http from "./http_common";

class UserService {

   queryString(payload) {
      const QueryString = Object.keys(payload).map((key) => (key && payload[key] && key + "=" + payload[key])).join('&');
      return QueryString;
   }

   getUser(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/user/list/filter?${queryString}`);
   }
   getUserCount(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/user/userCountStatus?${queryString}`);
   }

   getEnrolledUsers(payload) {
      if (payload) {
         const queryString = this.queryString(payload);
         return http.get(`/enrollmentFormDetails/list/filter?${queryString}`);
      }
      else {
         return http.get(`/enrollmentFormDetails/list/filter`);
      }
   }

   getEnrolledUsersCount(payload) {
      const queryString = this.queryString(payload)
      return http.get(`/enrollmentFormDetails/enrollmentFormDetailsCountStatus?${queryString}`);
   }

   updateEnrolledUser(payload) {
      return http.put(`/enrollmentFormDetails/update/${payload.id}`, payload);
   }

   saveEnrolledUserRemarks(payload) {
      return http.post('/enrollmentFormRemarks/save', payload);
   }

   getSavedRemarks(payload) {
      const queryString = this.queryString(payload)
      return http.get(`/enrollmentFormRemarks/list/filter?${queryString}`);
   }

   userActiveInactive(payload) {
      return http.put('/user/update/status', payload);
   }

   addUser(payload) {
      return http.post('/user/', payload);
   }
   addEnrollmentUser(payload) {
      return http.post('/WebsiteUser/enroll/', payload);
   }
   editUser(payload, id) {
      return http.put(`/user/${id}`, payload);
   }

   UserFilter(payload) {
      const queryString = Object.entries(payload)
         .filter(
            ([_, value]) => value !== undefined && value !== null && value !== ""
         )
         .map(([key, value]) => `${key}=${value}`)
         .join("&");

      return http.get(`/user/list/filter?${queryString}`);
   }

   enrollUserFilter(payload) {
      const queryString = Object.entries(payload)
         .filter(
            ([_, value]) => value !== undefined && value !== null && value !== ""
         )
         .map(([key, value]) => `${key}=${value}`)
         .join("&");

      return http.get(`/enrollmentFormDetails/list/filter?${queryString}`);
   }

   getDoctorSpeciality(payload) {
      const queryString = this.queryString(payload)
      return http.get(`/Speciality/list?${queryString}`);
   }

   userLabMap(payload) {
      return http.post('/userLabMap/save', payload);
   }

   userPharmacyMap(payload) {
      return http.post('/userPharmacyMap/save', payload);
   }

   getuserMappedLabs(payload) {
      const queryString = this.queryString(payload)
      return http.get(`/userLabMap/list/filter?${queryString}`);
   }

   getuserMappedPharmacies(payload) {
      const queryString = this.queryString(payload)
      return http.get(`/userPharmacyMap/list/filter?${queryString}`);
   }

   getUserMappedClinics(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/UserClinicMaster/list/filter?${queryString}`);
   }

   userMultiClinicMapping(payload) {
      return http.post('/UserClinicMaster/', payload);
   }

   referedList(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/Referral/list/filter?${queryString}`);
   }

   referedListCount(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/Referral/referralCountStatus?${queryString}`);
   }

   referToSave(payload) {
      return http.post(`/Referral/`, payload);
   }

   getOrderList(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/patientAppointment/pharamacyAndLabOrder/list/filter?${queryString}`);
   }

   getOrderListCount(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/patientAppointment/patientAppointmentCountStatus?${queryString}`);
   }

   getUserMappedTemp(data) {
      const queryString = this.queryString(data);
      return http.get(`/userTemplates/list/userTemplates?${queryString}`);
   }

   userTempMapping(payload) {
      return http.post('/userTemplates/save', payload);
   }

   userStampAndSign(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/user/getStampAndSignature?${queryString}`);
   }

}

export default new UserService();